import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import cx from "classnames"
import _get from "lodash/get"
import { NumericFormat } from "react-number-format"

import Button from "@/components/core/Button/Button"
import { selectCartState } from "@/store/features/cartSlice"
import styles from "@/components/ProductDetail/v3/StickyHeader/index.module.scss"
import { replaceAddToCartDatalayerPush } from "@/components/ProductDetail/v3/AddToCart/analytics"
import { useRouter } from "next/router"
import { getStock } from "@/utils/cart"

const StickyHeader = props => {
  const {
    staticTexts: {
      addToCart = "",
      notifyMailCTA = "",
      findSimilar = "",
      preOrder = "",
      specialOrder = "",
      availColorCTA = "",
    },
    productStock = "",
    backOrder = "",
    disableEcommerce = "",
    replaceAddToCart = () => {},
    replaceAddToCartCtaLabel = "",
    price = 0,
    onAddToCart = () => {},
    sku = "",
    isComboSku = "",
    customerBrandName = "",
    imgUrl = "",
    title = "",
    color = "",
    currencySign = "",
    isDiscontinued = "",
    isColorDiscontinued = "",
    isRegionSoldOnline = "",
    onAvailableColor = () => {},
    handleScroll = () => {},
    replaceAddToCartCtaLink = "",
    linkNewTab = "",
    description = "",
    analyticData = {},
    productPriceSpiderIncluded = "",
    productInfo = {},
    installError,
    warehouses = [],
    setPinCodeError,
    isOutOfStock,
    installServiceData,
    isInstallationAdded,
    isBundle,
    pinCodeError,
    isEtaLoading,
    isPdpPropsLoaded
  } = props

  const router = useRouter()
  const { label, url } = color
  const [showBuyBoxArea, setShowBuyBoxArea] = useState(true)
  const itemStatus = _get(props, "itemStatus", "available")
  const { cart } = useSelector(selectCartState)
  const [loading, setLoading] = useState(false)
  let buttonText =
    isOutOfStock === "Currently, this product is out of stock for your location"
      ? notifyMailCTA
      : addToCart
  let analyticsAddToCart =
    '{"eventAction":"pdp:sticky nav:add to cart","eventName":"pdp:sticky nav:add to cart","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"add to cart","internalLinkPosition":"header","internalLinkType":"pdp:add to cart","internalLinkZoneName":"pdp:sticky nav","internalLinkURL":"n/a","clickInternalLinks":"true"}'
  if (itemStatus === "outOfStock" || !(productStock > 0)) {
    buttonText = notifyMailCTA
    analyticsAddToCart = JSON.stringify({
      clickInternalLinks: "true",
      eventAction: "pdp:sticky nav:notify me",
      eventMsg: "n/a",
      eventName: "pdp:sticky nav:notify me",
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: "notify me",
      internalLinkPosition: "header",
      internalLinkType: "pdp:notify me",
      internalLinkURL: "n/a",
      internalLinkZoneName: "pdp:sticky nav",
    })
    if (props.specialOrder === "Yes" || backOrder === "Yes") {
      buttonText = addToCart
      analyticsAddToCart =
        '{"eventAction":"pdp:sticky nav:add to cart","eventName":"pdp:sticky nav:add to cart","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"add to cart","internalLinkPosition":"header","internalLinkType":"pdp:add to cart","internalLinkZoneName":"pdp:sticky nav","internalLinkURL":"n/a","clickInternalLinks":"true"}'
    }
  } else if (itemStatus === "discontinued") {
    buttonText = findSimilar
    analyticsAddToCart =
      '{"eventAction":"pdp:find similar items","eventName":"pdp:find similar items","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"find similar items","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}'
  } else if (itemStatus === "preOrder") {
    buttonText = preOrder
    analyticsAddToCart =
      '{"eventAction":"pdp:pre order","eventName":"pdp:pre order","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"pre order","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}'
  } else if (itemStatus === "specialOrder") {
    buttonText = specialOrder
    analyticsAddToCart =
      '{"eventAction":"pdp:special order","eventName":"pdp:special order","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"special order","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}'
  }

  const analyticsWhereToBuy =
    disableEcommerce &&
    replaceAddToCart &&
    replaceAddToCartCtaLabel &&
    JSON.stringify({
      clickInternalLinks: "true",
      eventAction: `pdp:sticky nav:${replaceAddToCartCtaLabel}`,
      eventMsg: "n/a",
      eventName: `pdp:sticky nav:${replaceAddToCartCtaLabel}`,
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: `${replaceAddToCartCtaLabel}`,
      internalLinkPosition: "header",
      internalLinkType: `pdp:${replaceAddToCartCtaLabel}`,
      internalLinkURL: "n/a",
      internalLinkZoneName: `pdp:${replaceAddToCartCtaLabel}`,
    })

  useEffect(() => {
    if (productPriceSpiderIncluded) {
      setShowBuyBoxArea(false)
    } else if (!price) {
      setShowBuyBoxArea(false)
    } else {
      setShowBuyBoxArea(true)
    }
  }, [productPriceSpiderIncluded, price])
  const onAddToCartCb = () => {
    setLoading(false)
  }
  const handleScrollToMsg = () => {
    const element = document.querySelector(".pdp-install-service")
    if (element) {
      const offsetPosition = element.offsetTop - 100
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      })
    }
  }

  const handleClick = () => {
    setLoading(true)
    if (pinCodeError) {
      setPinCodeError(true)
      handleScrollToMsg()
      setLoading(false)
      return
    }
    if (isEtaLoading || !isPdpPropsLoaded) {
      setLoading(false)
      return
    }
    if (!pincode) {
      setLoading(false)
      setPinCodeError(true)
      handleScrollToMsg()
      return
    }
    if (buttonText === notifyMailCTA) {
      window.scroll({
        top: 800,
        left: 0,
        behavior: "smooth",
      })
    } else {
      if (analyticsAddToCart && window.adobeDataLayer) {
        const eventInfo = JSON.parse(analyticsAddToCart)
        const page = window.adobeDataLayer.getState("page")
        const productArray = [productInfo]
        window.adobeDataLayer.push({
          event: "cmp:click",
          eventInfo,
          page,
          productArray,
        })
      }
      getStock(sku).then(stock => {
        const cartItem =
          cart.lineItems?.find(item => item.variant.sku === sku) ?? {}
        let custom = cartItem?.custom ?? {}
        if (installServiceData?.isInstallation && isInstallationAdded) {
          const payload = [
            {
              sku: sku,
              quantity: 1,
              isBundle: isBundle,
              brand: customerBrandName?.toLowerCase(),
              isInstallService: true,
              installServiceName: installServiceData?.sku,
              installServiceQty: 1,
              warehouses: warehouses,
              custom,
            },
          ]
          if (!isBundle) {
            if (Object.keys(cartItem).length === 0) {
              custom = {
                fields: { associatedProduct: sku, warehouses: warehouses },
              }
            }
            payload.push({
              sku: installServiceData?.sku,
              quantity: 1,
              isBundle: false,
              brand: customerBrandName?.toLowerCase(),
              warehouses: warehouses,
              custom,
            })
          }

          onAddToCart(payload, onAddToCartCb)
        } else {
          onAddToCart(
            [
              {
                sku: sku,
                quantity: 1,
                isBundle: isBundle,
                backorder: backOrder === "Yes" ? true : false,
                brand: customerBrandName?.toLowerCase(),
                warehouses: warehouses,
              },
            ],
            onAddToCartCb
          )
        }
      })
    }
  }

  const getCookieValue = name =>
    document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || ""

  const pincode = getCookieValue("pincode")

  return (
    <div className={styles.pdpStickyHeadWrapper}>
      <div className="pdp-sticky-header container-fluid">
        <div className="pdp-sticky-header__details-wrap container-fluid">
          <div className="pdp-sticky-header__container kf-react-plp-container">
            <div className="pdp-sticky-header__details">
              <span className="pdp-sticky-header__brand-name">{title}</span>
              <p className="pdp-sticky-header__description">{description}</p>
            </div>

            {showBuyBoxArea && (
              <div
                className={cx({
                  "pdp-sticky-header__right": true,
                  "pdp-sticky-header__right--retailers":
                    productPriceSpiderIncluded,
                })}
              >
                {isDiscontinued ? (
                  isColorDiscontinued && !disableEcommerce ? (
                    <Button
                      role="button"
                      useDefaultClass={true}
                      label={availColorCTA}
                      size="small"
                      type="primary"
                      onClick={() => onAvailableColor()}
                    />
                  ) : null
                ) : isRegionSoldOnline &&
                  (productStock > 0 ||
                    specialOrder === "Yes" ||
                    backOrder === "Yes") &&
                  !disableEcommerce ? (
                  <Button
                    label={buttonText}
                    size="small"
                    type="primary"
                    role={"button"}
                    onClick={handleClick}
                    loading={loading}
                    disabled={loading || !price}
                    customClass="pdp-sticky-header__button"
                  />
                ) : isRegionSoldOnline && !disableEcommerce ? (
                  <Button
                    role="button"
                    className={`${analyticsAddToCart ? "gbh-data-layer" : ""}`}
                    data-gbh-data-layer={`${analyticsAddToCart || null}`}
                    data-gbh-data-layer-custom={analyticData}
                    label={buttonText}
                    size="small"
                    type="primary"
                    disabled={loading || !price}
                    onClick={handleScroll}
                    customClass="pdp-sticky-header__button"
                  />
                ) : null}

                {replaceAddToCart ? (
                  <Button
                    onClick={() => {
                      replaceAddToCartDatalayerPush(
                        replaceAddToCartCtaLabel,
                        replaceAddToCartCtaLink,
                        analyticData
                      )
                      router.push(replaceAddToCartCtaLink)
                    }}
                    useDefaultClass={true}
                    className="gbh-data-layer"
                    data-gbh-data-layer={analyticsWhereToBuy}
                    data-gbh-data-layer-custom={analyticData}
                    role="button"
                    ariaLabel={replaceAddToCartCtaLabel}
                    label={replaceAddToCartCtaLabel}
                    size="small"
                    type="primary"
                    to={replaceAddToCartCtaLink}
                    target={linkNewTab ? "_blank" : "_self"}
                  />
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

StickyHeader.defaultProps = {
  productStock: "",
  backOrder: "",
  disableEcommerce: "",
  replaceAddToCart: "",
  replaceAddToCartCtaLabel: "",
  onAddToCart: "",
  sku: "",
  isComboSku: "",
  customerBrandName: "",
  title: "",
  isDiscontinued: "",
  isColorDiscontinued: "",
  isRegionSoldOnline: "",
  onAvailableColor: "",
  handleScroll: "",
  replaceAddToCartCtaLink: "",
  linkNewTab: "",
  imgUrl: "",
  productSku: "",
  brandName: "",
  description: "",
  currencySign: "",
  price: 0,
  itemStatus: "available",
  color: {
    label: "",
    url: "",
  },
  staticTexts: {
    addToCart: "",
    notifyMailCTA: "",
    findSimilar: "",
    preOrder: "",
    specialOrder: "",
    availColorCTA: "",
  },
}

export default StickyHeader
